$(".fg input").each(function(index, el) {
    InputIsFilled($(el))
});

$(".fg textarea").each(function(index, el) {
    InputIsFilled($(el))
});


$(".fg select").each(function(index, el) {
    InputIsFilled($(el))
});

$(".fg input").change(function() {
    InputIsFilled($(this))
})

$(".fg textarea").change(function() {
    InputIsFilled($(this))
})

$(".fg select").change(function() {
    InputIsFilled($(this))
})

function InputIsFilled(el) {
    if ($(el).val()) {
        $(el).addClass("input-active")
    } else {
        $(el).removeClass("input-active")
    }
}

$(".m-select").niceSelect()

$(document).ready(function() {
    $('input[type="tel"]').mask('+7 999 999-9999', { autoclear: false }, { placeholder: '+7             ' });
    $('.bank-card-field').mask('9999-9999-9999-9999', { autoclear: false }, { placeholder: '    -    -    -   ' });
});

$(".call__btn").click(function () {
    $(".call").toggleClass("_active")
})


$(document).mouseup(function(e) {
    var div = $('.call');
    if (!div.is(e.target) && div.has(e.target).length === 0) {
        if($(div).hasClass("_active")){
            $(div).removeClass("_active")
        }
    }
});

$(".spoiler-card__show").click(function () {
    $(this).toggleClass("_active")
    $(this).siblings(".spoiler-card__hidden").slideToggle()
})

$(".rating-input__item").click(function() {
    let ratingItem = parseInt($(this).attr("data-rating-value"))
    $(this).parent(".rating-input").attr("data-total-rating", ratingItem)
    $(this).siblings(".rating-input__field").val(ratingItem)
})

$("[data-link-href]").click(function () {
    let linkHref = $(this).attr("data-link-href")
    window.location.href = linkHref;
})


$('.video').click(function() {
    let video = $(this).find("video")
    if(video[0].paused){
        video[0].play()
        $(this).addClass("_played")
    } else{
        video[0].pause()
        $(this).removeClass("_played")
    }
});

$("._tab").click(function() {
    let parentBlock = $(this).parents(".tabs-parent")
    let tabId = $(this).attr("data-tab")
    console.log(parentBlock)
    console.log(tabId)
    $(parentBlock).find("._tab").removeClass("_active")
    $(this).addClass("_active")
    $(parentBlock).find("._tab-content").removeClass("_active")
    $(parentBlock).find(`._tab-${tabId}`).addClass("_active")
})

$(".m-tooltip__wrap").click(function () {
    $(".m-tooltip__wrap").removeClass("_active")
    $(this).addClass("_active")
})

$(document).mouseup(function(e) {
    var div = $('.m-tooltip__wrap');
    if (!div.is(e.target) && div.has(e.target).length === 0) {
        if($(div).hasClass("_active")){
            $(div).removeClass("_active")
        }
    }
});

let fancybox = document.querySelectorAll("[data-fancybox]")

Fancybox.defaults.placeFocusBack = false

new AirDatepicker('.date-input', {
    locale: localeRu,
    // inline: true,
    // isMobile: true,
    autoClose: true,
    onSelect: () => {
        $(".date-input").addClass("input-active")
    }
})
